import { useEffect, useState } from "react";
import { crossIcon, SaveShareMixLinkIcon, SaveShareMixWhatsappIcon } from "../../Assets/svg";
import RoundAudio from "../RoundAudio";
import {
    WhatsappIcon,
    WhatsappShareButton
} from "react-share";
import { Modal } from "react-bootstrap";
import BASEURLFrontend from "../../Config/urls";
import { useDispatch, useSelector } from "react-redux";
import { encryptId } from "../../Services/Common";
import { useTranslation } from "react-i18next";


const ShareMixModal = ({ isOpen, onClose, tracks }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const id = useSelector((state) => state.mixStatus.mixId);
    const { selectedItem, shareSystemCreatedPlaylist } = useSelector((state) => state.player);
    const shareList = selectedItem.length > 0 ? selectedItem : tracks;

    const [shareUrl, setShareUrl] = useState({
        '3_min': '',
        '15_min': '',
        "type": null
    });

    const [copiedText, setCopiedText] = useState(false);
    const [selectOptionModal, setSelectOptionModal] = useState(false);
    const userPrompts = useSelector((state) => state.user.userPrompts);

    useEffect(() => {
        if (id) {
            setShareUrl({
                ...shareUrl,
                '3_min': getEncrytedUrl(180),
                '15_min': getEncrytedUrl(900)
            })
        }
    }, [id]);

    const selectOptionType = (type) => {
        if (JSON.parse(localStorage.getItem("allowextendedmix")) == true) {
            setShareUrl({ ...shareUrl, 'type': type });
            setSelectOptionModal(true);
        } else {
            copylink(180);
        }
    }

    const copylink = (sec) => {
        const url = getEncrytedUrl(sec);
        copied(url);
    }

    const copied = (url) => {
        var textField = document.createElement('textarea')
        textField.innerText = url
        document.body.appendChild(textField)
        textField.select()
        document.execCommand('copy')
        setCopiedText(true);
        textField.remove();
        setTimeout(() => {
            setCopiedText(false);
        }, 1000);
    }

    const checkArticleIsIncludes = () => {
        const isArticleExists = shareList?.some((item) => item.type === "articles")
        if (isArticleExists) {
            return true;
        }
        return false
    }

    const getEncrytedUrl = (sec) => {
        const playlist_root_name = shareSystemCreatedPlaylist ? "share.playlist.default" : "share.playlist"
        const pathName = window.location.pathname == "/playlists" ? playlist_root_name : "share.mix";
        const url = `${BASEURLFrontend}/${pathName}/${encryptId(sec)}/${encryptId(id)}`
        return url;
    }


    return (
        <>
            <Modal show={isOpen} centered className="mixer-modal" backdrop="static">
                <Modal.Body>
                    <div className="share-mix-popup">
                        <div className="share-mix-wrapper d-flex flex-column">
                            <div className="d-flex flex-column flex-grow-1 ">
                                <div className="save-mix-header text-end">
                                    <button className="notButton ms-auto d-flex align-items-center p-4" onClick={() => onClose('share-mix')}>
                                        <img src={crossIcon} alt="Close Button" className="img-fluid" style={{ width: '15px' }} />
                                    </button>
                                </div>
                                <div className="share-mix-wrapper-inner d-flex flex-column flex-grow-1 mt-2">

                                    <div className="flex-shrink-0">
                                        <h5 className="text-center fs-3 mb-0">{t("mixes.shareYourMix")}</h5>
                                    </div>

                                    <div className="flex-shrink-0 my-4">
                                        <div className="save-share-sounds">
                                            <div className="soundBoxWrapper">
                                                {shareList?.map((item, index) => (
                                                    <div key={index} className={`roundAudioWrapper`}>
                                                        <div className={`roundAudio ${index}`}>
                                                            <div className="imageWrapper">
                                                                <img
                                                                    src={item?.image}
                                                                    alt="Sound Thumbnail"
                                                                />
                                                            </div>
                                                            <p>{item.title}</p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="save-share-mix-icon-wrapper flex-shrink-0">

                                        <div className="d-flex align-items-center justify-content-center">
                                            <div className="mx-2 d-sm-none">
                                                {
                                                    JSON.parse(localStorage.getItem("allowextendedmix")) == false ? (
                                                        <div className="whatsapp-icon position-relative">
                                                            <WhatsappShareButton
                                                                url={shareUrl?.["3_min"]}
                                                                beforeOnClick={() => { }}
                                                                quote={'Scofa Relax'}
                                                                hashtag={'#portfolio...'}
                                                            >
                                                                <WhatsappIcon size={50} round={true} />
                                                            </WhatsappShareButton>
                                                            <button className="notButton">
                                                                <img src={SaveShareMixWhatsappIcon} alt="Close Button" style={{ width: '50px' }} />
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <button className="notButton" onClick={() => selectOptionType('whatsapp')}>
                                                            <img src={SaveShareMixWhatsappIcon} alt="Close Button" style={{ width: '50px' }} />
                                                        </button>
                                                    )
                                                }
                                            </div>
                                            <div className="copy-link-icon position-relative mx-2">
                                                <button className="notButton" onClick={() => selectOptionType('copy')}>
                                                    <img src={SaveShareMixLinkIcon} alt="copy icon" style={{ width: '50px' }} />
                                                </button>
                                            </div>
                                        </div>

                                        {checkArticleIsIncludes() &&
                                            <div className="d-flex align-items-center justify-content-center mt-4">
                                                <small className="text-center">{userPrompts?.age_restriction_notification || t("modals.medicalArticleRestriction")}</small>
                                            </div>
                                        }
                                    </div>

                                    <div className="" style={{ height: '80px' }}></div>

                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Extendable Mix Modal */}
            <Modal
                show={selectOptionModal}
                centered
                className="copied-modal select-option-modal"
                style={{ marginTop: '-10px' }}
                backdrop="static"
            >
                <Modal.Body>
                    <div className="pb-5 pt-0">
                        <div className="d-flex pb-4 mb-2">
                            <button className="closeButton notButton ms-auto" onClick={() => setSelectOptionModal(false)}>
                                <img src={crossIcon} alt="Close Button" className="img-fluid" style={{ width: '15px' }} />
                            </button>
                        </div>
                        <div className="text-center mb-4 pb-3">
                            <h5>{t("modals.selectOption")}</h5>
                        </div>
                        <div className="d-flex align-items-center justify-content-center gap-3 mb-4">
                            {
                                shareUrl?.type == 'whatsapp' ? (
                                    <>
                                        <button style={{ backgroundColor: '#ffffff1f' }} className='px-4 py-2 fs-6 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0 position-relative'>
                                            <WhatsappShareButton
                                                url={shareUrl?.["3_min"]}
                                                beforeOnClick={() => { }}
                                                quote={'Scofa Relax'}
                                                hashtag={'#portfolio...'}
                                            >
                                                <WhatsappIcon />
                                            </WhatsappShareButton>
                                            <span className='flex-shrink-0 me-2'>{t("modals.threeMin")}</span>
                                            <CopyIcon />
                                        </button>
                                        <button style={{ backgroundColor: '#ffffff1f' }} className='px-4 py-2 fs-6 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0 position-relative'>
                                            <WhatsappShareButton
                                                url={shareUrl?.["15_min"]}
                                                beforeOnClick={() => { }}
                                                quote={'Scofa Relax'}
                                                hashtag={'#portfolio...'}
                                            >
                                                <WhatsappIcon />
                                            </WhatsappShareButton>
                                            <span className='flex-shrink-0 me-2'>{t("modals.fifteenMin")}</span>
                                            <CopyIcon />
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <button style={{ backgroundColor: '#ffffff1f' }} className='px-4 py-2 fs-6 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0' onClick={() => copylink(180)}>
                                            <span className='flex-shrink-0 me-2'>{t("modals.threeMin")}</span>
                                            <CopyIcon />
                                        </button>
                                        <button style={{ backgroundColor: '#ffffff1f' }} className='px-4 py-2 fs-6 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0' onClick={() => copylink(900)}>
                                            <span className='flex-shrink-0 me-2'>{t("modals.fifteenMin")}</span>
                                            <CopyIcon />
                                        </button>
                                    </>
                                )
                            }


                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Copied Modal End */}

            {/* Copied Modal */}
            <Modal
                show={copiedText}
                centered
                className="copied-modal"
                style={{ marginTop: '-10px' }}
                backdrop="static"
            >
                <Modal.Body>
                    <div className="p-5">
                        <h2 className="font-16 lh-16 m-0 fw-normal text-center py-5 my-5">{userPrompts?.link_copied_notification}</h2>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Copied Modal End */}
        </>
    )
}

export default ShareMixModal


const CopyIcon = ({ height = 22 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 106.09 106.09">
            <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_18" data-name="Layer 18">
                    <path class="cls-2" d="M54.86,66.24,47.13,74A10.2,10.2,0,0,1,32.71,59.55l7.73-7.73a3.24,3.24,0,0,0-4.58-4.59L28.13,55a16.68,16.68,0,1,0,23.59,23.6l7.73-7.74a3.24,3.24,0,0,0-4.59-4.58Z" />
                    <path class="cls-2" d="M78,28.72a16.69,16.69,0,0,0-23.59,0l-7.73,7.73A3.24,3.24,0,0,0,51.22,41L59,33.3A10.2,10.2,0,0,1,73.38,47.73l-7.73,7.73A3.24,3.24,0,1,0,70.23,60L78,52.31A16.69,16.69,0,0,0,78,28.72Z" />
                    <path class="cls-2" d="M37.94,68.74a3.25,3.25,0,0,0,4.58,0L68.15,43.12a3.25,3.25,0,0,0-4.59-4.59L37.94,64.16A3.25,3.25,0,0,0,37.94,68.74Z" />
                </g>
            </g>
        </svg>
    )
}